// extracted by mini-css-extract-plugin
export default {"wrapper":"CopyrightWrapper_wrapper__oJcee"};